export const FCU = 'FCU';
export const FDP = 'FDP';
export const DCB = 'DCB';
export const PCB = 'PCB';
export const FDM = 'FDM';
export const ADM = 'ADM';
export const ODM = 'ODM';
export const PB = 'PB';
export const DI = 'DI';
export const PI = 'PI';
export const LB = 'LB';
export const AP = 'AP';
export const FPB = 'FPB';
export const DB = 'DB';

export const selectFCU = () => {
    return {
        type: FCU,
        payload: true
    };
}

export const removeFCU = () => {
    return {
        type: FCU,
        payload: false
    };
}

export const selectFDP = () => {
    return {
        type: FDP,
        payload: true,
    };
}

export const removeFDP = () => {
    return {
        type: FDP,
        payload: false,
    };
}

export const selectDCB = () => {
    return {
        type: DCB,
        payload: true,
    };
}

export const removeDCB = () => {
    return {
        type: DCB,
        payload: false,
    };
}

export const selectPCB = () => {
    return {
        type: PCB,
        payload: true,
    };
}

export const removePCB = () => {
    return {
        type: PCB,
        payload: false,
    };
}

export const selectFDM = () => {
    return {
        type: FDM,
        payload: true,
    };
}

export const removeFDM = () => {
    return {
        type: FDM,
        payload: false,
    };
}

export const selectADM = () => {
    return {
        type: ADM,
        payload: true,
    };
}

export const removeADM = () => {
    return {
        type: ADM,
        payload: false,
    };
}

export const selectODM = () => {
    return {
        type: ODM,
        payload: true,
    };
}

export const removeODM = () => {
    return {
        type: ODM,
        payload: false,
    };
}

export const selectPB = () => {
    return {
        type: PB,
        payload: true,
    };
}

export const removePB = () => {
    return {
        type: PB,
        payload: false,
    };
}

export const selectDI = () => {
    return {
        type: DI,
        payload: true,
    };
}

export const removeDI = () => {
    return {
        type: DI,
        payload: false,
    };
}

export const selectPI = () => {
    return {
        type: PI,
        payload: true,
    };
}

export const removePI = () => {
    return {
        type: PI,
        payload: false,
    };
}

export const selectLB = () => {
    return {
        type: LB,
        payload: true,
    };
}

export const removeLB = () => {
    return {
        type: LB,
        payload: false,
    };
}

export const selectAP = () => {
    return {
        type: AP,
        payload: true,
    };
}

export const removeAP = () => {
    return {
        type: AP,
        payload: false,
    };
}

export const selectFPB = () => {
    return {
        type: FPB,
        payload: true,
    };
}

export const removeFPB = () => {
    return {
        type: FPB,
        payload: false,
    };
}

export const selectDB = () => {
    return {
        type: DB,
        payload: true,
    };
}

export const removeDB = () => {
    return {
        type: DB,
        payload: false,
    };
}


// WEBPACK FOOTER //
// ./src/actions/selectUlnarMuscle.js